import {  LOGIN_DETAILS, LOGIN_ERROR, AUTH_LOGIN } from './../constant/ActionTypes';

export const loginReducer = (state, action) => {
    switch (action.type) {
        case LOGIN_DETAILS:
            return { ...state, loginDetails: action.payload };
        case LOGIN_ERROR:
            return { ...state, loginError: action.payload };
        case AUTH_LOGIN:
            return { ...state, authLogin: action.payload };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./contexts/reducer/loginReducer.js